import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Layout, Message, Steps, Typography, theme } from "@payping/web-components";

import { Constants as routerConstants } from "@/refund/routes";
import useTranslator from "@/shared/translate/translator";
import { BottomSheetContainer } from "@/shared/components";

import ContractView from "@/refund/views/contract";
import { useInitializeUser } from "@/refund/use-cases";
import { UserInitializationTypeEnum } from "@/refund/repository/refund/v1/refund-v1-api";

const Contract: React.FC = () => {
  const { t } = useTranslator("refund");
  const navigate = useNavigate();
  const { lg } = Grid.useBreakpoint();
  const { token } = theme.useToken();

  const initializeUser = useInitializeUser();

  const [step] = useState<number>(0);

  // const onConfirmContact = useCallback(() => {
  //   setStep(1);
  // }, [setStep]);

  const onConfirmContact = useCallback(async () => {
    try {
      await initializeUser.mutateAsync({ userInitializationType: UserInitializationTypeEnum.AllIpgTypesAndPanInquiry });
      Message.success({ content: t("setting.success") });
      navigate(routerConstants.wallet.url);
    } catch (error) {
      //
    }
  }, [initializeUser, navigate, t]);

  // const onConfirmSetting = useCallback(
  //   async (userInitializationType: number) => {
  //     try {
  //       await initializeUser.mutateAsync({ userInitializationType });
  //       Message.success({ content: t("setting.success") });
  //       navigate(routerConstants.wallet.url);
  //     } catch (error) {
  //       //
  //     }
  //   },
  //   [navigate, initializeUser, t],
  // );

  useEffect(() => {
    document.title = t("name");
  }, [t]);

  const stepsContent = (
    <Steps
      direction="vertical"
      current={step}
      items={[
        {
          title: t("contract.title"),
          description: <Typography.Text type="secondary">{t("contract.subtitle")}</Typography.Text>,
        },
        // {
        //   title: t("setting.title"),
        //   description: <Typography.Text type="secondary">{t("setting.subtitle")}</Typography.Text>,
        // },
      ]}
    />
  );

  const desktopContent = (
    <Layout.Sider
      className="!tw-m-0 !tw-w-64 !tw-min-w-64 !tw-max-w-64 tw-border-0 tw-border-e-[1px] tw-border-solid tw-border-[#f0f0f0] !tw-py-[8px]"
      style={{ backgroundColor: token.colorBgBase }}
    >
      {stepsContent}
    </Layout.Sider>
  );

  return (
    <BottomSheetContainer title={t("name")}>
      <Layout className="tw-min-h-[80vh]">
        {lg && desktopContent}
        <Layout.Content className="tw-px-[32px] tw-py-[8px]">
          {step === 0 && <ContractView onConfirm={onConfirmContact} loading={initializeUser.isPending} />}
          {/* {step === 1 && <SettingView onConfirm={onConfirmSetting} loading={initializeUser.isPending} />} */}
        </Layout.Content>
      </Layout>
    </BottomSheetContainer>
  );
};
export default Contract;
